module.exports = __webpack_public_path__ + "img/icloud-1.80c6beac.png";